/**
 * 文字列が対象参照（`slide:…` / `element:…`）の形かを見る。
 *
 * **メンションの表記を読む器はドメインを知らない。** ui-kit の `tokenizeMentions` は
 * `@[名前](なにか)` の形だけを見て読むため、`@[a](b)` のような偶然の並びもメンションとして
 * 返る。対象として扱うかどうかはここで濾す。参照の意味づけを持つのはこちら側である。
 */
export function isTargetRef(value: string): boolean {
    return (
        (value.startsWith("slide:") && value.length > "slide:".length) ||
        (value.startsWith("element:") && value.length > "element:".length)
    );
}
